<app-dialog
	modalTitle="Adicionar Benefício Congênere"
	titleButton="Adicionar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid || isLoading"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<ng-container *ngIf="isLoading">
		<div class="d-f jc-c ai-c w-100 mt-giant">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>

	<ng-container *ngIf="!isLoading">
		<div class="p-xs" [formGroup]="form">
			<mat-radio-group
				formControlName="planType"
				class="d-f fd-c mb-sm"
				aria-label="Selecione o tipo de plano"
			>
				<p class="fs-sm fw-bold mb-sm">Tipo de Plano Congênere*</p>
				<mat-radio-button color="primary" [value]="partnerTypeEnum.HEALTH">
					Saúde
				</mat-radio-button>
				<mat-radio-button color="primary" [value]="partnerTypeEnum.TEETH">
					Dental
				</mat-radio-button>
				<mat-error
					*ngIf="
						form.get('planType')?.hasError('required') &&
						form.get('planType')?.touched
					"
				>
					Selecione o tipo de plano (Saúde ou Dental).
				</mat-error>
			</mat-radio-group>

			<mat-form-field
				class="w-100"
				title="Plano Congênere"
				appearance="outline"
				*ngIf="form.get('planType')?.value"
			>
				<mat-label>Plano Congênere*</mat-label>
				<mat-select formControlName="benefitId">
					<mat-option *ngFor="let ben of availableBenefits" [value]="ben?.id">
						{{ ben?.name }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="form.get('benefitId')?.hasError('required')">
					Selecione o plano.
				</mat-error>
			</mat-form-field>

			<mat-form-field
				class="w-100"
				title="Carteirinha Congênere"
				appearance="outline"
				*ngIf="form.get('planType')?.value"
			>
				<mat-label>Carteirinha Congênere*</mat-label>
				<input
					type="text"
					matInput
					placeholder="Número da carteirinha"
					formControlName="walletNumber"
					id="sk-congener-{{ inputId }}"
				/>
				<mat-error *ngIf="form.get('walletNumber')?.hasError('required')">
					Informe o número da carteirinha.
				</mat-error>
			</mat-form-field>

			<mat-form-field
				class="w-100 mb-lg"
				title="Início de Vigência Congênere"
				appearance="outline"
				*ngIf="form.get('planType')?.value"
			>
				<mat-label>Início de Vigência Congênere*</mat-label>
				<input
					matInput
					placeholder="DD/MM/AAAA"
					formControlName="startDate"
					id="vig-congener-{{ inputId }}"
					[matDatepicker]="pickerCongener"
				/>
				<mat-datepicker-toggle matSuffix [for]="pickerCongener">
					<mat-icon
						matDatepickerToggleIcon
						svgIcon="sanus-calendar-blue"
					></mat-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #pickerCongener></mat-datepicker>
				<mat-error *ngIf="form.get('startDate')?.hasError('required')">
					Informe a data de início de vigência.
				</mat-error>
			</mat-form-field>
		</div>
	</ng-container>
</app-dialog>
